module.exports = __webpack_public_path__ + "img/tagoil.1610dedd.png";